import { Table } from 'react-bootstrap';

const Step6 = ({ formData }) => {
  const renderSection = (title, keys) => (
    <>
      <h6 className="mt-4 text-primary">{title}</h6>
      <Table bordered size="sm" responsive>
        <tbody>
          {keys.map((key) => (
            <tr key={key}>
              <td className="fw-bold text-capitalize">{key.replace(/([A-Z])/g, ' $1')}</td>
              <td>{formData[key] || <em className="text-muted">N/A</em>}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );

  return (
    <div>
      <h5 className="mb-3">Step 6: Confirm & Submit</h5>
      <p>Please review the details below before submission:</p>

      {renderSection('Type & House Info', [
        'rateClass',
        'customerType',
        'applicationType',
        'specialAccount',
        'connectedLoad',
        'propertyOwnership',
      ])}

      {renderSection('Personal Information', [
        'lastName',
        'firstName',
        'middleName',
        'suffix',
        'secondaryLastName',
        'secondaryFirstName',
        'secondaryMiddleName',
        'birthdate',
        'nationality',
        'sex',
        'maritalStatus',
      ])}

      {renderSection('Contact Person & Info', [
        'contactLastName',
        'contactFirstName',
        'contactMiddleName',
        'contactSuffix',
        'contactRelationship',
        'email',
        'tel1',
        'tel2',
        'mobile1',
        'mobile2',
      ])}

      {renderSection('Govt ID & Requirements', [
        'govtIdType',
        'govtIdName',
        'govtIdNumber',
        'isSenior',
        'seniorDate',
        'seniorId',
      ])}

      {/* ✅ Replace all old address fields with just 2 full address fields */}
      <h6 className="mt-4 text-primary">Address</h6>
      <p>{formData.address || <em className="text-muted">N/A</em>}</p>

      <h6 className="mt-4 text-primary">Billing Address</h6>
      <p>{formData.billAddress || <em className="text-muted">N/A</em>}</p>

      <div className="text-end mt-4">
        <p className="text-muted">Click Submit to complete your application.</p>
      </div>
    </div>
  );
};

export default Step6;
